import { render, staticRenderFns } from "./RDCdissociated.vue?vue&type=template&id=69256890&scoped=true"
import script from "./RDCdissociated.vue?vue&type=script&lang=js"
export * from "./RDCdissociated.vue?vue&type=script&lang=js"
import style0 from "./RDCdissociated.vue?vue&type=style&index=0&id=69256890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69256890",
  null
  
)

export default component.exports